<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <center>
          <p style="font-size: 2vw">درج اطلاعات عملکردی</p>
          <hr>
          <br>
        </center>

        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات مالی</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50"
                           to="/Financial_management_and_productivity/functional_information/Financial">تکمیل اطلاعات /
                بروزرسانی
              </router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات ستانده</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50"
                           to="/Financial_management_and_productivity/functional_information/received">تکمیل اطلاعات /
                بروزرسانی
              </router-link>
            </center>
          </div>
        </div>
        <br>
        <div class="d-flex flex-nowrap ">
          <div class="card p-4 w-50">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات پیامد</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50"
                           to="/Financial_management_and_productivity/functional_information/Consequences">تکمیل اطلاعات
                / بروزرسانی
              </router-link>
            </center>
          </div>
          <div class="card p-4 w-50 mx-2">
            <center>
              <p style="font-weight: bold; font-size: 1.3vw;">اطلاعات اثر</p>
              <br>
              <router-link class="btn btn-submit-1 btn-info w-50"
                           to="/Financial_management_and_productivity/functional_information/effect">تکمیل اطلاعات /
                بروزرسانی
              </router-link>
            </center>
          </div>
        </div>
        <br>
        <div class="d-flex flex-nowrap">
          <div class="card p-4 w-50 d-flex">
            <p style="font-weight: bold; font-size: 1.3vw;">مدیریت طرح</p>
            <br>
            <router-link class="btn btn-submit-1 btn-info w-50 mx-auto"
                         to="/Financial_management_and_productivity/functional_information/plan-management">
              تکمیل اطلاعات / بروزرسانی
            </router-link>
          </div>
          <div class="card p-4 w-50 mx-2">
            <p style="font-weight: bold; font-size: 1.3vw;">نیروی کار</p>
            <br>
            <router-link class="btn btn-submit-1 btn-info w-50 mx-auto"
                         to="/Financial_management_and_productivity/functional_information/labor">
              تکمیل اطلاعات / بروزرسانی
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  methods: {
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }
}
</script>
